/**
 * Branded types for units
 */

import type { Float } from "@pdfking/tfunc"

/**
 * Size in user unit
 */
export type Distance = Float<"Distance">

export type Pixel = Float<"Pixel">

export type Measure = Distance | Pixel

export type Percentage = Float<"Percentage">

export type Degree = Float<"Degree">

export type Radian = Float<"Radian">

export type ColorComponent = Float<"ColorComponent">
